import React from 'react';
import trustpilotFiveStars from './assets/TrustpilotFiveStars.svg';
import { QuoteIcon, VerifiedIcon } from './icons';
import {
  AuthorDate,
  AuthorMeta,
  AuthorNameStrong,
  AuthorSep,
  CardFooter,
  CardQuoteTitleRow,
  CardTopRow,
  Quote,
  QuoteIconWrap,
  QuoteWrapper,
  ReviewTitle,
  StarsRow,
  TestimonialCard,
  TrustpilotStarsImg,
  VerifiedBadge,
  VerifiedIconWrap,
  VerifiedLabel,
} from './styles';
import { ReviewContent } from './types';

type Props = {
  review: ReviewContent;
};

const ReviewPanel: React.FC<Props> = ({ review }) => (
  <TestimonialCard>
    <CardTopRow>
      <StarsRow>
        <TrustpilotStarsImg
          src={trustpilotFiveStars}
          alt=""
          width={98}
          height={18}
          loading="lazy"
        />
      </StarsRow>
      <VerifiedBadge>
        <VerifiedIconWrap>
          <VerifiedIcon />
        </VerifiedIconWrap>
        <VerifiedLabel>Verified</VerifiedLabel>
      </VerifiedBadge>
    </CardTopRow>

    <CardQuoteTitleRow>
      <QuoteIconWrap>
        <QuoteIcon />
      </QuoteIconWrap>
      <ReviewTitle>{review.title}</ReviewTitle>
    </CardQuoteTitleRow>

    <QuoteWrapper>
      <Quote>{review.text}</Quote>
    </QuoteWrapper>

    <CardFooter>
      <AuthorMeta>
        <AuthorNameStrong>{review.displayName}</AuthorNameStrong>
        <AuthorSep> · </AuthorSep>
        <AuthorDate>{review.createdAt}</AuthorDate>
      </AuthorMeta>
    </CardFooter>
  </TestimonialCard>
);

export default ReviewPanel;
